import { Container, HStack, Text } from '@chakra-ui/react'
import sortBy from 'lodash/sortBy'
import type { ChangeEventHandler } from 'react'
import { useState } from 'react'

import { NativeSelectField, NativeSelectRoot } from '@app/components/ui/native-select'
import CopyButton from '@app/pages/strategies/components/aiChat/components/copyButton'
import { PageStack } from '@app/shared/layout'
import { useStore } from '@app/store'
import { AmplitudeEventTaxonomy as TaxonomyQuery } from '@graphql/documents/metric_source.graphql'
import { useSuperAdminCredentialsQuery } from '@graphql/queries'
import type { AmplitudeEventTaxonomyQuery, AmplitudeEventTaxonomyQueryVariables } from '@graphql/queries'
import type { AmplitudeEvent } from '@graphql/types'

const AmplitudeEventTaxonomy = () => {
  const [credentialId, setCredentialId] = useState<string | null>(null)
  const [taxonomy, setTaxonomy] = useState<Pick<AmplitudeEvent, 'name' | 'category' | 'description'>[]>(null)
  const loaderQuery = useStore.use.loaderQuery()

  const [{ data }] = useSuperAdminCredentialsQuery({
    variables: {
      sourceName: 'MetricSources::Amplitude'
    }
  })
  const credentials = data?.superAdminCredentials || []

  const onChange: ChangeEventHandler<HTMLSelectElement> = async (event) => {
    const selectedId = event.target.value || null
    setCredentialId(selectedId)

    if (!selectedId) {
      setTaxonomy(null)
      return
    }

    const result = await loaderQuery<AmplitudeEventTaxonomyQuery, AmplitudeEventTaxonomyQueryVariables>(TaxonomyQuery, {
      credentialId: selectedId
    })

    const mapped = result?.data?.amplitudeEventTaxonomy?.map((e) => ({
      name: e.name,
      description: e.description,
      category: e.category
    }))

    setTaxonomy(mapped)
  }

  const stringifiedTaxonomy = JSON.stringify(taxonomy || '', null, '\t')
  return (
    <PageStack>
      <Container>
        <NativeSelectRoot>
          <NativeSelectField name="credentialId" placeholder="None" value={credentialId} onChange={onChange}>
            {sortBy(credentials, 'displayName').map((cred) => (
              <option key={cred.id} value={cred.id}>
                {cred.displayName}
              </option>
            ))}
          </NativeSelectField>
        </NativeSelectRoot>
      </Container>
      {taxonomy && taxonomy.length > 0 && (
        <Container>
          <HStack>
            <Text fontSize="xl">Copy result</Text>
            <CopyButton content={stringifiedTaxonomy} />
          </HStack>
        </Container>
      )}
      <Container>
        <pre>{stringifiedTaxonomy}</pre>
      </Container>
    </PageStack>
  )
}

export default AmplitudeEventTaxonomy
